import { GROUP_A_OPTION } from "../constants.js";

/**
 * @typedef {import("../jsdoc/ProgramManager.js").ProgramManager} ProgramManager
 */

/**
 * Filters Program Managers based on provided filter options
 * @param {ProgramManager[]} programManagers
 * @param {Object} options options for how contract holders list should be filtered
 * @param {Object} options.groupOptions
 * @param {string} options.groupOptions.group
 * @param {string} options.groupOptions.facet
 * @param {number[]} options.otherOptions
 * @returns {ProgramManager[]}
 */
export const filterProgramManagers = (programManagers, { groupOptions }) => {
  if (groupOptions.group) {
    if (groupOptions.facet) {
      programManagers = programManagers.filter(({ contracts }) =>
        contracts.find(
          ({ group, businessSizes }) =>
            (groupOptions.group === GROUP_A_OPTION ? group === GROUP_A_OPTION : group.match(/Group [BCD]/)) &&
            businessSizes.find((businessSize) => groupOptions.facet === businessSize.displayName)
        )
      );
    } else {
      programManagers = programManagers.filter(({ contracts }) =>
        contracts.find(({ group }) =>
          groupOptions.group === GROUP_A_OPTION ? group === GROUP_A_OPTION : group.match(/Group [BCD]/)
        )
      );
    }
  }
  return programManagers;
};
